<template>
  <div class="customer-detail-box">
    <div class="customer-base">
      <div class="customer-base-content">
        <div class="customer-base-title">
          <span>基础信息</span>
          <div class="customer-base-edit" @click="clueDialogForm">
            <i class="arsenal_icon arsenalbianji"></i>
          </div>
        </div>
        <div class="customer-base-content">
          <div class="customer-base-box1">
            <div class="customer-base-image" v-if="clueInfo.profilePhoto">
              <el-avatar shape="square" :size="80" fit="fit" :src="clueInfo.profilePhoto"></el-avatar>
            </div>
            <div class="customer-base-image" v-else>
              <el-avatar shape="square" :size="80" fit="fit"
                         src="https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png"></el-avatar>
            </div>
            <div class="customer-base-info">
              <div class="customer-base-name">
                <span class="real-name" v-if="clueInfo.name">{{ clueInfo.name }}</span>
                <span class="real-name" v-else>未知姓名</span>
                <span v-show="clueInfo.externalType == 1" class="wechat">@微信</span>
                <span v-show="clueInfo.externalType == 2" class="ewechat">@企业微信</span>
                <span v-if="clueInfo.position">{{ clueInfo.position }}</span>
                <Span v-else>--</Span>
              </div>
              <div class="customer-base-company">
                <span v-if="clueInfo.companyInfo">{{ clueInfo.companyInfo.name }}</span>
                <span v-else>--</span>
              </div>
              <div class="customer-base-label">
                <div class="customer-base-label-item labelBlue">
                  来源:
                  <span v-if="clueInfo.source==='ROBOT_PUSH'">对话机器人</span>
                  <span v-if="clueInfo.source==='ADD_MANULLY'">手动录入</span>
                  <span v-if="clueInfo.source==='WECHAT_GROUP_ADD'">企业微信群</span>
                  <span v-if="clueInfo.source==='SCAN_CODE'">活码</span>
                  <span v-if="clueInfo.source==='API_PUSH'">API推送</span>
                  <span v-if="clueInfo.source==='VIEW_BUSINESS_CARD'">智能名片</span>
                  <span v-if="clueInfo.source==='CUSTOM_FORM'">自定义表单</span>
                  <span v-if="clueInfo.source==='EWECHAT_ADD'">企业微信好友</span>
                </div>
                <div class="customer-base-label-item labelRed" v-show="!clueInfo.reachedByWeChat">
                  <i class="arsenal_icon arsenalcommnet-alt-slash"></i>
                  <span>未添加好友</span>
                </div>
              </div>
            </div>
          </div>
          <div class="customer-base-box2">
            <div class="customer-base-box2-item">
              <div class="title">
                <span>电话</span>
              </div>
              <div class="content">
                <span v-if="clueInfo.mobile">{{ clueInfo.mobile }}</span>
                <span v-else>--</span>
              </div>
            </div>
            <div class="customer-base-box2-item">
              <div class="title">
                <span>微信号</span>
              </div>
              <div class="content">
                <span v-if="clueInfo.weChatNo">{{ clueInfo.weChatNo }}</span>
                <span v-else>--</span>
              </div>
            </div>
            <div class="customer-base-box2-item">
              <div class="title">
                <span>生日</span>
              </div>
              <div class="content">
                <span v-if="clueInfo.birthDay">{{ new Date(clueInfo.birthDay).Format('yyyy-MM-dd') }}</span>
                <span v-else>--</span>
              </div>
            </div>
            <div class="customer-base-box2-item">
              <div class="title">
                <span>邮箱</span>
              </div>
              <div class="content">
                <span v-if="clueInfo.mail">{{ clueInfo.mail }}</span>
                <span v-else>--</span>
              </div>
            </div>
            <div class="customer-base-box2-item">
              <div class="title">
                <span>地址</span>
              </div>
              <div class="content">
                <span v-if="clueInfo.address">{{ clueInfo.address }}</span>
                <span v-else>--</span>
              </div>
            </div>
            <div class="customer-base-box2-item">
              <div class="title">
                <span>跟进人</span>
              </div>
              <div class="content">
                <span v-if="clueInfo.follower">{{ clueInfo.follower.name }}</span>
                <span v-else>--</span>
                <el-link type="primary" @click="newLeadsAssign">重新分配</el-link>
                <el-link type="primary" @click="changeLeadsStatus" v-if="clueInfo.follower">释放公海</el-link>
              </div>
            </div>
            <div class="customer-base-box2-item">
              <div class="title">
                <span>描述</span>
              </div>
              <div class="content">
                <span v-if="clueInfo.description">{{ clueInfo.description }}</span>
                <span v-else>--</span>
              </div>
            </div>
            <div class="customer-base-box2-item">
              <div class="title">
                <span>添加时间</span>
              </div>
              <div class="content">
                <span
                    v-if="clueInfo.createTime">{{ new Date(clueInfo.createTime).Format('yyyy-MM-dd hh:mm:ss') }}</span>
                <span v-else>--</span>
              </div>
            </div>
            <div class="customer-base-box2-item">
              <div class="title">
                <span>更新时间</span>
              </div>
              <div class="content">
                <span
                    v-if="clueInfo.updateTime">{{ new Date(clueInfo.updateTime).Format('yyyy-MM-dd hh:mm:ss') }}</span>
                <span v-else>--</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="cutomer-source-analysis">
           <div class="customer-source-title">
               <span>来源追溯</span>
           </div>
           <div class="customer-source-content">
               <div id="myChart" :style="{width: '100%', height: '150px'}"></div>
           </div>
       </div>-->
      <div class="customer-base-tag">
        <div class="customer-base-title">
          <span>标签</span>
          <div class="customer-base-edit" @click="editTags">
            <i class="arsenal_icon arsenalbianji"></i>
          </div>
        </div>
        <div class="customer-base-content" v-if="clueInfo.tags">
          <el-tag
              v-for="tag in clueInfo.tags"
              :key="tag.id"
          >{{ tag.name }}
          </el-tag>
        </div>
      </div>
    </div>
    <div class="customer-followup">
      <el-tabs v-model="activeName"  @tab-click="handleClick">
        <el-tab-pane label="跟进记录" name="first">
          <div class="customer-followup-content" :class="replayRecordInput?'show-record-followup-content':'hide-record-followup-content'">
            <div class="follow-up-opration">
              <div class="oprationLeft">
                <div class="status">跟进状态：
                  <span v-if="clueInfo.status">{{ clueInfo.status.name }}</span>
                  <span v-else>--</span>
                </div>
                <el-button size="mini" type="primary" @click="editStatus">修改跟进状态</el-button>
              </div>
              <el-button type="primary" icon="el-icon-plus" @click="addFollowBtn"></el-button>
            </div>
            <el-timeline>
              <el-timeline-item
                  :timestamp="new Date(follow.createTime).Format('yyyy/MM/dd hh:mm:ss')"
                  v-for="(follow,index) in followUpList"
                  placement="top"

              >
                <el-card>

                  <div class="followTitle">
                    <div class="follow-title-left">
                      <span v-if="follow.editorName">{{ follow.editorName }}</span>
                      <span v-else>--</span>
                      通过<span class="labelBlue">{{ follow.way|waysFilter }}</span>
                      于{{ new Date(follow.startTime).Format('yyyy-MM-dd') }}跟进 <span
                        style="color:#409eff;margin-left:10px;font-size:20px"><!--<i class="el-icon-view " @click="innerDrawer = true"></i>--></span>
                      <span v-if="follow.prevStatus&&follow.status&&follow.prevStatusId!==follow.statusId"
                            class="followStatusShow">跟进状态由<span
                          class="labelBlue">{{ follow.prevStatus.name }}</span>更新为<span
                          class="labelBlue">{{ follow.status.name }}</span></span>
                      <span
                          v-if="follow.status&&!follow.prevStatusId || (follow.status&&follow.prevStatusId&&follow.prevStatusId===follow.statusId)"
                          class="followStatusShow">跟进状态不变<span class="labelBlue">({{ follow.status.name }})</span></span>
                    </div>
                    <div class="follow-title-right" @click="replayRecord(follow)">
                      <el-button type="text">回复</el-button>
                    </div>

                  </div>
                  <div class="follow-content">
                    <h4>{{ follow.description }}</h4>
                    <div class="follow-replay-content" v-if="follow.replies">
                      <el-collapse accordion>
                        <el-collapse-item>
                          <template slot="title">
                            跟进记录回复
                          </template>
                          <div class="replay-item" v-for="(item,index) in follow.replies" :key="item.id">
                            <div class="replay-name-time">
                              <el-divider content-position="left">
                                <span class="replay-editname" v-if="item.editorName">{{item.editorName}}</span>
                                <span class="replay-time">{{new Date(item.createTime).Format('yyyy-MM-dd hh:mm')}}</span>
                              </el-divider>
                              
                            </div>

                            <span class="replay-des">{{item.description}}</span>
                          </div>
                        </el-collapse-item>
                      </el-collapse>

                    </div>
                  </div>

                </el-card>
              </el-timeline-item>
            </el-timeline>

          </div>
        </el-tab-pane>
        <el-tab-pane label="客户动态" name="second" v-if="false">
          <div class="customer-followup-content hide-record-followup-content">
            <el-timeline>
              <el-timeline-item
                  placement="top"
                  v-for="trends in trendsList"
                  :key="trends.id"
              >
                <el-card v-if="trends.event==='SHARE_CARD'">
                  <h4>分享了<span class="red">{{ trends.eventInfo.card.memberInfo.name }}</span>的<span class="labelBlue">智能名片</span>
                  </h4>
                  <p> {{ new Date(trends.createTime).Format('yyyy-MM-dd hh:mm:ss') }}</p>
                </el-card>
                <el-card v-if="trends.event==='VIEW_CARD'">
                  <h4>查看了<span class="red">{{ trends.eventInfo.card.memberInfo.name }}</span>的<span class="labelBlue">智能名片</span>
                  </h4>
                  <p> {{ new Date(trends.createTime).Format('yyyy-MM-dd hh:mm:ss') }}</p>
                </el-card>
                <el-card v-if="trends.event==='ASK_BOT'">
                  <h4>
                    在<span class="red">{{ trends.eventInfo.card.memberInfo.name }}</span>的名片中与<span class="labelBlue">机器人</span>进行了对话
                    <span style="color:#409eff;margin-left:10px;font-size:20px;cursor: pointer"
                          @click="openChatDrawer(trends)"><i class="el-icon-view "></i></span>
                  </h4>
                  <p> {{ new Date(trends.createTime).Format('yyyy-MM-dd hh:mm:ss') }}</p>
                </el-card>
                <el-card v-if="trends.event==='ADD_FRIEND'">
                  <h4>
                    <span class="red" v-if="trends.eventInfo.clue">{{ trends.eventInfo.clue.name }}</span>添加了<span
                      v-if="trends.eventInfo.friend" style="color: #409eff">{{ trends.eventInfo.friend.name }}</span>为好友
                  </h4>
                  <p> {{ new Date(trends.createTime).Format('yyyy-MM-dd hh:mm:ss') }}</p>
                </el-card>
              </el-timeline-item>
            </el-timeline>
          </div>
        </el-tab-pane>
        <!-- <el-tab-pane label="对话记录" name="third">
             <chat-content style="height:calc(100vh - 120px)"></chat-content>
         </el-tab-pane>-->
      </el-tabs>
      <div class="add-record-record" :class="replayRecordInput?'show-record-record':'hide-record-record'">
        <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 3}"
            placeholder="请输入回复内容"
            v-model="followUpRecordDes">
        </el-input>
        <div class="replay-btn">
          <el-button size="small" @click="replayRecordInput=false">取消</el-button>
          <el-button size="small" type="primary" @click="addReplay">添加</el-button>
        </div>
      </div>
    </div>
    <!-- 添加标签对话框 -->
    <el-dialog
        title="提示"
        :visible.sync="addTagDialogVisible"
        :close-on-click-modal="false"
        :append-to-body="true"
        width="30%">
      <tag-selection ref="tagSelection"></tag-selection>
      <span slot="footer" class="dialog-footer">
            <el-button @click="addTagDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="addTags">确 定</el-button>
        </span>
    </el-dialog>
    <!-- 添加标签对话框 -->
    <el-dialog
        title="添加跟进记录"
        :visible.sync="addFllowUpDialogVisible"
        :close-on-click-modal="false"
        :append-to-body="true"
        width="30%">
      <add-fllow-up ref="addFollowUp"></add-fllow-up>
      <span slot="footer" class="dialog-footer">
            <el-button @click="addFllowUpDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="addFollow">确 定</el-button>
        </span>
    </el-dialog>
    <!-- 线索分配对话框 -->
    <el-dialog
        title="线索分配"
        :visible.sync="leadsAssignDialogVisible"
        :close-on-click-modal="false"
        :append-to-body="true"
        width="40%">
      <leads-assign ref="leadsAssign"></leads-assign>
      <span slot="footer" class="dialog-footer">
            <el-button @click="leadsAssignDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="leadsAssign">确 定</el-button>
        </span>
    </el-dialog>
    <!-- 对话记录抽屉 -->
    <el-dialog
        title="修改客户线索"
        :visible.sync="clueDialogFormVisible"
        width="30%"
        :close-on-click-modal="false"
        append-to-body
    >
      <div class="leads-add-box">
        <el-form v-model="leadsClueForm">
          <el-form-item label="姓名" :label-width="formLabelWidth">
            <el-input v-model="leadsClueForm.name" placeholder="请输入客户名称" clearable></el-input>
          </el-form-item>
          <!--                  <el-form-item label="昵称" :label-width="formLabelWidth">
                                <el-input v-model="leadsClueForm.nickName" placeholder="请输入客户昵称" clearable></el-input>
                            </el-form-item>-->
          <el-form-item label="性别" :label-width="formLabelWidth">
            <el-radio-group v-model="leadsClueForm.gender" size="medium">
              <el-radio-button label="男"></el-radio-button>
              <el-radio-button label="女"></el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="生日" :label-width="formLabelWidth">
            <el-date-picker
                v-model="leadsClueForm.birthDay"
                type="date"
                placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="电话" :label-width="formLabelWidth">
            <el-input
                v-model="leadsClueForm.mobile"
                placeholder="请输入客户联系方式"
                clearable
                @blur="phoneClick(leadsClueForm.mobile)"
            ></el-input>
          </el-form-item>
          <el-form-item label="微信号" :label-width="formLabelWidth">
            <el-input
                v-model="leadsClueForm.weChatNo"
                placeholder="请输入客户微信号"
                clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="跟进人" :label-width="formLabelWidth">
            <el-select
                v-model="leadsClueForm.followerId"
                placeholder="请选择跟进人"
                style="width: 100%"
            >
              <el-option
                  v-for="follow in followerList"
                  :key="follow.userid"
                  :label="follow.name"
                  :value="follow.userid"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="跟进状态" :label-width="formLabelWidth">
            <el-select
                v-model="leadsClueForm.statusId"
                placeholder="请选择跟进状态"
                style="width: 100%"
            >
              <el-option
                  v-for="status in status.list"
                  :key="status.id"
                  :label="status.name"
                  :value="status.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="邮箱" :label-width="formLabelWidth">
            <el-input
                v-model="leadsClueForm.mail"
                placeholder="请输入客户邮箱"
                clearable
                @blur="emailClick(leadsClueForm.mail)"
            ></el-input>
          </el-form-item>
          <el-form-item label="公司" :label-width="formLabelWidth">
            <div style="display: flex;justify-content: space-between;align-items: center">
              <el-select
                  v-model="leadsClueForm.companyId"
                  placeholder="请选择公司"
                  style="position: relative"
              >

                <el-input
                    placeholder="可搜索"
                    v-model="clueCompanyValue"
                    clearable
                    style="position: absolute;top: 0px;z-index: 9;"
                    size="medium"
                    @input="customerClueCompanySelect"
                >
                  <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
                <div
                    style="margin-top: 36px"
                    v-if="customerClue.companyList.length > 0"
                >
                  <el-option
                      v-for="item in customerClue.companyList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </div>
                <div
                    v-else
                    style="margin-top: 36px"
                >
                  <el-option style="display: flex;justify-content: center;align-items: center">
                    暂无数据
                  </el-option>
                </div>
              </el-select>
              <el-link type="primary" style="margin-left:20px;flex: none;width: 60px" @click="clueAddCompany">新增公司
              </el-link>
            </div>

          </el-form-item>
          <el-form-item label="部门" :label-width="formLabelWidth">
            <el-input v-model="leadsClueForm.department" placeholder="请输入客户所在部门" clearable></el-input>
          </el-form-item>
          <el-form-item label="职位" :label-width="formLabelWidth">
            <el-input v-model="leadsClueForm.position" placeholder="请输入客户职位" clearable></el-input>
          </el-form-item>
          <el-form-item label="地址" :label-width="formLabelWidth">
            <el-input v-model="leadsClueForm.address" placeholder="请输入客户详细地址" clearable></el-input>
          </el-form-item>

          <el-form-item label="描述" :label-width="formLabelWidth">
            <el-input
                type="textarea"
                placeholder="请输入内容"
                v-model="leadsClueForm.description"
                maxlength="200"
                show-word-limit
            ></el-input>
          </el-form-item>

        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="caleCustomerClue">取 消</el-button>
        <el-button type="primary" @click="editCustomerClue">修 改</el-button>
      </div>
    </el-dialog>

    <!--修改跟进状态-->
    <el-dialog
        title="修改跟进状态"
        :visible.sync="editStatusDialogFormVisible"
        :close-on-click-modal="false"
        append-to-body
        width="500px"
    >
      <el-form :model="status">
        <el-form-item label="跟进状态" :label-width="statusFormLabelWidth">
          <el-select
              v-model="status.id"
              placeholder="请选择跟进状态"
          >
            <el-option
                v-for="sta in status.list"
                :key="sta.id"
                :label="sta.name"
                :value="sta.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editStatusDialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="editFollowStatus">修 改</el-button>
      </div>
    </el-dialog>

    <!--查看聊天记录-->
    <el-drawer
        title="聊天记录"
        :visible.sync="chatDrawer"
        append-to-body
        size="40%"
        direction="rtl">
      <chat-content style="height:calc(100vh - 120px);" ref="chatContent"></chat-content>
    </el-drawer>

  </div>
</template>

<script>
import tagSelection from '../../../components/tagSelection.vue'
import AddFllowUp from './addFllowUp.vue';
import ChatContent from './chatContent.vue';
import LeadsAssign from './leadsAssign.vue';

export default {
  components: {tagSelection, AddFllowUp, LeadsAssign, ChatContent},
  data() {
    return {
      activeName: 'first',
      addTagDialogVisible: false,
      addFllowUpDialogVisible: false,
      leadsAssignDialogVisible: false,
      clueDialogFormVisible: false,
      innerDrawer: false,
      editStatusDialogFormVisible: false,
      leadsForm: {
        nickName: '',
        gender: '',
        birthday: '',
        address: '',
        companyId: "",
        department: "",
        description: "",
        mail: "",
        name: "",
        position: "",
        source: "ADD_MANULLY",
        mobile: ''
      },
      followList: [],
      customerClue: {
        companyList: [],
        sourceList: [],
      },
      selectCompanyList: [],
      formLabelWidth: '80px',
      clueCompanyValue: '',
      followUpList: [],
      status: {
        id: '',
        list: []
      },
      statusFormLabelWidth: '80px',
      pageSize: 10000,
      currentPage: 1,
      trendsList: [],
      leadsClueForm: {},
      followerList: [],
      customerId: '',
      clueInfo: {
        nickName: '',
        gender: '',
        birthday: '',
        address: '',
        companyId: "",
        department: "",
        description: "",
        mail: "",
        name: "",
        position: "",
        source: "",
        mobile: '',
        followerId: '',
        weChatNo: ''
      },
      chatDrawer: false,
      addCompanySuccess:false,
      followUpRecordDes:'',
      replayRecordInput:false,
      replayFollow:{}
    }
  },
  filters: {
    waysFilter(value) {
      console.log(value)
      if (value === 'MOBILE')
        return '电话'
      else if (value === 'ONSITEVISIT')
        return '现场拜访'
      else if (value === 'MESSAGE')
        return '短信'
      else if (value === 'INTERVIEW')
        return '面谈'
      else if (value === 'WECHAT')
        return '微信'
      else if (value === 'ENTERPRISEWECHAT')
        return '企业微信'
      else if (value === 'DINGDING')
        return '钉钉'
      else if (value === 'TELECONFERENCE')
        return '远程会议'
      else
        return '其他'

    }
  },
  mounted() {
    this.getStatusList()
    this.getClientCompany()
    this.leadsClueForm = JSON.parse(JSON.stringify(this.clueInfo))
  },
  props: ['customerClueInfo', 'clueId', 'tags'],
  methods: {
    //回复
    replayRecord(follow){
      console.debug('follow',follow)
      this.replayFollow = follow
      this.replayRecordInput = true
    },
    //添加回复
    addReplay(){
      this.replayRecordInput = false
      let url = '/scrm-api/custom-clue/follow-up-record-record/'+this.replayFollow.id
      let data = {
        description:this.followUpRecordDes
      }
      this.$http.put(url,data).then(res=>{
        console.debug('replay success',res)
        if (res.status===200){
          this.$message({
            message:'回复成功',
            duration:2000,
            type:'success'
          })
          this.getFollow(this.clueId)
        }
      })

    },
    //切换tab
    handleClick(){
      this.replayRecordInput = false
    },
    //查看聊天记录
    openChatDrawer(item) {
      this.chatDrawer = true
      console.log(item)
      if (item.eventInfo && item.eventInfo.dialogInfo) {
        this.$nextTick(() => {
          this.$refs.chatContent.messageList = []
          this.$refs.chatContent.clickUserli(item.eventInfo.dialogInfo, true, true, null)
        })
      }
    },
    drawLine() {
      var echarts = require('echarts');
      var myChart = echarts.init(document.getElementById('myChart'));
      myChart.setOption({
        tooltip: {},
        animationDurationUpdate: 1500,
        animationEasingUpdate: 'quinticInOut',
        series: [
          {
            type: 'graph',
            layout: 'none',
            symbolSize: 40,
            roam: true,
            label: {
              show: true
            },
            edgeSymbol: ['circle', 'arrow'],
            edgeSymbolSize: [4, 10],
            edgeLabel: {
              fontSize: 20
            },
            data: [{
              name: '郑俊成',
              x: 200,
              y: 300
            }, {
              name: '陈勇',
              x: 400,
              y: 300
            }, {
              name: '吴明岩',
              x: 550,
              y: 300
            }, {
              name: '高鹏',
              x: 700,
              y: 450
            }],
            // links: [],
            links: [{
              source: '郑俊成',
              target: '陈勇'
            }, {
              source: '陈勇',
              target: '吴明岩'
            }, {
              source: '吴明岩',
              target: '高鹏'
            }
              , {
                source: '郑俊成',
                target: '高鹏'
              }],
            lineStyle: {
              opacity: 0.9,
              width: 2,
              curveness: 0
            }
          }
        ]
      });
    },
    //获取具体客户线索
    getCustomerDetail(id) {
      let url = '/scrm-api/custom-clue/' + id
      this.$http.get(url).then(res => {
        this.clueInfo = {
          nickName: '',
          gender: '',
          birthday: '',
          address: '',
          companyId: "",
          department: "",
          description: "",
          mail: "",
          name: "",
          position: "",
          source: "",
          mobile: '',
          followerId: '',
          weChatNo: ''
        }
        console.log('resres', res)
        this.clueInfo = res.data
        if (res.data.name) {
          this.clueInfo.name = res.data.name
        }
        if (res.data.nickName) {
          this.clueInfo.nickName = res.data.nickName
        }
        if (res.data.gender) {
          this.clueInfo.gender = res.data.gender
        }
        if (res.data.birthDay) {
          this.clueInfo.birthday = res.data.birthDay
        }
        if (res.data.mobile) {
          this.clueInfo.mobile = res.data.mobile
        }
        if (res.data.weChatNo) {
          this.clueInfo.weChatNo = res.data.weChatNo
        }
        if (res.data.followerId) {
          this.clueInfo.followerId = res.data.followerId
        }
        if (res.data.mail) {
          this.clueInfo.mail = res.data.mail
        }
        if (res.data.companyId) {
          this.clueInfo.companyId = res.data.companyId
        }
        if (res.data.department) {
          this.clueInfo.department = res.data.department
        }
        if (res.data.position) {
          this.clueInfo.position = res.data.position
        }
        if (res.data.address) {
          this.clueInfo.address = res.data.address
        }
        if (res.data.description) {
          this.clueInfo.description = res.data.description
        }
        this.clueInfo.source = res.data.source
      })
    },
    changeLeadsStatus() {
      this.$confirm('此操作将线索放入公海, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let memberId = ''
        let url = '/scrm-api/custom-clue/follower/' + this.clueId + '?followerId=' + memberId
        this.$http.put(url).then(res => {
          console.log(res)
          if (res.status === 200) {
            this.$message({
              message: '释放公海成功',
              duration: 2000,
              type: 'success'
            })
            this.getCustomerDetail(this.clueId)
            this.$emit('editClue')
          }
        })
        /*  this.$message({
              type: 'success',
              message: '删除成功!'
          });*/
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
          duration: 2000
        });
      });
    },
    //获取公司的下拉列表值
    getClientCompany() {
      this.$http.get('/api/client-company/page?num=' + this.pageSize + '&page=' + this.currentPage)
          .then(response => {
            this.customerClue.companyList = response.data.data.content;
            this.selectCompanyList = response.data.data.content
            if (this.addCompanySuccess){
              this.leadsClueForm.companyId=this.customerClue.companyList[this.customerClue.companyList.length - 1].id
            }
          })
    },
    customerClueCompanySelect() {
      if (this.clueCompanyValue !== '') {
        let selectCompany = []
        this.selectCompanyList.forEach((item) => {
          if (!!~item.name.indexOf(this.clueCompanyValue) || !!~item.name.toUpperCase().indexOf(this.clueCompanyValue.toUpperCase())) {
            selectCompany.push(item)
          }
        })
        this.customerClue.companyList = selectCompany

      } else {
        this.customerClue.companyList = this.selectCompanyList
      }
    },
    clueAddCompany() {
      this.$emit('clueCompanyAdd')
    },
    addFollowBtn() {
      this.addFllowUpDialogVisible = true

      this.$nextTick(() => {
        console.log(this.$refs.addFollowUp)

        this.$refs.addFollowUp.followupForm.way = ''
        this.$refs.addFollowUp.followupForm.description = ''
        this.$refs.addFollowUp.statusList = this.status.list
        if (this.clueInfo.status && this.clueInfo.status.name !== '新建') {
          this.$refs.addFollowUp.followupForm.statusId = this.clueInfo.statusId
        } else {
          if (this.status.list.length > 0) {
            for (let i = 0; i < this.status.list.length; i++) {
              if (this.status.list[i].name == '跟进中') {
                this.$refs.addFollowUp.followupForm.statusId = this.status.list[i].id
              }
            }
          }
        }


      })
    },
    //添加跟进记录
    addFollow() {
      console.log(this.clueId)
      let followUp = {
        description: '',
        startTime: '',
        endTime: '',
        way: '',
        statusId: ''
      }
      let url = '/scrm-api/custom-clue/follow-up-record/' + this.clueId
      this.$nextTick(() => {
        console.log(this.$refs.addFollowUp.followupForm)
        followUp.description = this.$refs.addFollowUp.followupForm.description
        followUp.way = this.$refs.addFollowUp.followupForm.way
        followUp.startTime = this.$refs.addFollowUp.followupForm.time[0]
        followUp.endTime = this.$refs.addFollowUp.followupForm.time[1]
        followUp.statusId = this.$refs.addFollowUp.followupForm.statusId
        if (this.$refs.addFollowUp.followupForm.time === '' || this.$refs.addFollowUp.followupForm.time.length === 0) {
          this.$message({
            message: '请选择跟进时间',
            type: 'warning',
            duration: 2000
          })
          return
        }
        if (followUp.way === '') {
          this.$message({
            message: '请选择跟进方式',
            type: 'warning',
            duration: 2000
          })
          return
        }
        if (followUp.description === '') {
          this.$message({
            message: '请填写内容描述',
            type: 'warning',
            duration: 2000
          })
          return
        }
        console.log(followUp)
        this.$http.put(url, followUp).then(res => {
          if (res.status === 200) {
            this.$message({
              message: '添加跟进记录成功',
              duration: 2000,
              type: 'success'
            })
          }
          this.$emit('editClue')
          this.getFollow(this.clueId)
          this.getCustomerDetail(this.clueId)
          this.addFllowUpDialogVisible = false
        })
      })

    },
    //获取跟进记录
    getFollow(id) {
      console.log(this.clueId)
      let url = '/scrm-api/custom-clue/follow-up-record/' + id+'?withReplies=true'
      this.$http.get(url).then(res => {
        console.log('follow-up-record:', res.data)
        if (res.status === 200) {
          this.followUpList = res.data
          this.followUpList.reverse()
        }

      })
    },
    //获取全部状态
    getStatusList() {
      this.$http.get(' /scrm-api/followup-status').then(res => {
        console.log('response', res.data)
        this.status.list = res.data;
      })
    },
    //修改跟进状态
    editStatus() {
      this.editStatusDialogFormVisible = true
      if (this.clueInfo.status) {
        this.status.id = this.clueInfo.statusId
      } else {
        this.status.id = ''
      }
    },
    //修改跟进状态
    editFollowStatus() {

      if (this.status.id !== '') {
        let url = '/scrm-api/custom-clue/status/' + this.clueId + '?statusId=' + this.status.id
        this.$http.put(url).then(res => {
          if (res.status === 200) {
            this.$message({
              message: '修改跟进状态成功',
              duration: 2000,
              type: 'success'
            })
            this.getCustomerDetail(this.clueId)
            this.getFollow(this.clueId)
            this.$emit('editClue')
            this.editStatusDialogFormVisible = false
          }
        })
      } else {
        this.$message({
          message: '请选择要修改的跟进状态',
          duration: 2000,
          type: 'warning'
        })
      }


    },
    //取消修改客户详情
    caleCustomerClue() {
      this.clueDialogFormVisible = false
    },
    clueDialogForm() {
      this.clueDialogFormVisible = true
      this.leadsClueForm.weChatNo = ''
      this.leadsClueForm = JSON.parse(JSON.stringify(this.clueInfo))
    },
    //修改客户线索详情
    editCustomerClue() {
      let url = '/scrm-api/custom-clue/' + this.clueId
      if (this.leadsClueForm.name === '') {
        this.$message({
          message: '请填写客户名称',
          duration: 2000,
          type: 'success'
        })
        return;
      }
      if (!this.emailClick(this.leadsClueForm.mail)) {
        return;
      }
      if (!this.phoneClick(this.leadsClueForm.mobile)) {
        return
      }
      if (!this.leadsClueForm.mail && (!this.leadsClueForm.mobile) && (!this.leadsClueForm.weChatNo)) {
        this.$message({
          message: '手机号,邮箱,微信号最少填写一项',
          type: 'warning',
          duration: 2000
        })
        return;
      }
      this.$http.put(url, this.leadsClueForm).then(res => {
        console.log(res)
        if (res.status === 200) {
          this.$message({
            message: '修改客户线索成功',
            duration: 2000,
            type: 'success'
          })
          this.clueDialogFormVisible = false
          this.getCustomerDetail(this.clueId)
          this.$emit('editClue')
        }
      }).catch(res => {
        this.$message({
          message: '该手机号已添加过客户线索，请不要重复添加',
          duration: 3000,
          type: 'warning'
        })
      })

    },
    emailClick(mail) {
      const reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      console.log(mail)
      if (mail) {
        if (!reg.test(mail)) {
          this.$message('请输入有效的邮箱')
          return false
        } else {
          return true
        }
      } else {
        return true
      }

    },
    phoneClick(mobile) {
      const phone = /^[1][3,4,5,7,8][0-9]{9}$/
      var reg02 = /^(0[0-9]{2,3}\-)([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$/;
      if (mobile) {
        if (!phone.test(mobile) && !reg02.test(mobile)) {
          this.$message('请输入有效的电话号码')
          return false
        } else {
          return true
        }
      } else {
        return true
      }

    },
    //获取客户动态
    getTrends(id) {
      let url = '/scrm-api/custom-clue/customer-news/' + id
      this.$http.get(url).then(res => {
        console.log('获取的客户动态', res)
        if (res.status === 200) {
          this.trendsList = res.data
        }
      })
    },
    //添加标签
    addTags() {

      this.$nextTick(() => {
        console.log(this.$refs.tagSelection.tags)
        let ids = []
        let tagsList = this.$refs.tagSelection.tags
        tagsList.forEach(item => {
          ids.push(item.id)
        })
        let url = '/scrm-api/custom-clue/tags/' + this.clueId
        this.$http.put(url, ids).then(res => {
          console.log(res)
          if (res.status === 200) {
            this.$message({
              message: '标签更改成功',
              duration: 2000,
              type: 'success'
            })
            this.$emit('editClue')
            this.getCustomerDetail(this.clueId)
            this.addTagDialogVisible = false
          }
        })
      })
    },
    editTags() {
      this.addTagDialogVisible = true
      this.$nextTick(() => {
        console.log(this.clueInfo.tags)
        if (this.clueInfo.tags) {
          this.$refs.tagSelection.tags = this.clueInfo.tags
        } else {
          this.$refs.tagSelection.tags = []
        }
        if (this.clueInfo.tagIds) {
          this.$refs.tagSelection.$refs.tree.setCheckedKeys(this.clueInfo.tagIds)
        } else {
          this.$refs.tagSelection.$refs.tree.setCheckedKeys([])
        }

      })
    },
    newLeadsAssign() {
      this.leadsAssignDialogVisible = true
      this.$nextTick(() => {
        if (this.clueInfo.followerId) {
          this.$refs.leadsAssign.$refs.memberTree.member = this.clueInfo.followerId
        }
      })
    },
    leadsAssign() {

      this.$nextTick(() => {
        console.log(this.$refs.leadsAssign.$refs.memberTree.member)
        let memberId = this.$refs.leadsAssign.$refs.memberTree.member
        if (this.clueInfo.followerId!==memberId){
          if (memberId === '') {
            this.$message({
              message: '请选择分配跟进人',
              duration: 2000,
              type: 'warning'
            })
            return
          }
          let url = '/scrm-api/custom-clue/follower/' + this.clueId + '?followerId=' + memberId
          this.$http.put(url).then(res => {
            console.log(res)
            if (res.status === 200) {
              this.$message({
                message: '线索分配成功',
                duration: 2000,
                type: 'success'
              })
              this.$emit('editClue')
              this.getCustomerDetail(this.clueId)
            }
          })
        }
        this.leadsAssignDialogVisible = false
      })
    },
  }
}
</script>

<style lang="less" scoped>
.el-dialog {
  z-index: 9999 !important;
}

.labelBlue {
  color: #40a9ff;
}

.labelRed {
  color: red;
}

.customer-detail-box {
  padding: 0px 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .customer-base {
    display: flex;
    flex-direction: column;
    width: 40%;
    border-right: 1px solid #dddddd;
    padding: 0px 10px;
    overflow-y: scroll;
    height: calc(100vh - 80px);
    overflow-x: hidden;

    .customer-base-content {
      .customer-base-title {
        padding: 20px 0px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        span {
          width: 150px;
          color: #409eff;
          padding-bottom: 10px;
          padding-right: 20px;
          border-bottom: 3px solid #409eff;
        }

        .customer-base-edit {
          position: relative;
          top: 0px;
          right: 0px;
          cursor: pointer;

          i {
            font-size: 20px;
            color: #909399;
          }
        }
      }

      .customer-base-content {
        padding: 10px 0px;
        display: flex;
        flex-direction: column;
        color: #606266;

        .customer-base-box1 {
          display: flex;
          flex-direction: row;

          .customer-base-image {
            margin-right: 15px;
          }

          .customer-base-info {
            display: flex;
            flex-direction: column;

            .customer-base-name {
              font-size: 20px;
              margin-bottom: 5px;

              .real-name {
                margin-left: 0px !important;
              }

              .ewechat {
                color: #409eff;
                margin-left: 0px
              }

              .wechat {
                color: #67C23A;
                margin-left: 0px
              }

              span {
                font-size: 14px;
                color: #909399;
                margin-left: 10px;
              }
            }

            .customer-base-company {
              font-size: 14px;
              color: #909399;
              margin-bottom: 5px;
            }

            .customer-base-label {
              display: flex;
              flex-direction: row;

              .customer-base-label-item {
                display: flex;
                flex-direction: row;
                align-items: center;
                margin-right: 20px;

                span {
                  font-size: 14px;
                }
              }
            }
          }
        }

        .customer-base-box2 {
          display: flex;
          flex-direction: column;
          margin-top: 20px;
          font-size: 14px;

          .customer-base-box2-item {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin: 6px 5px;

            .title {
              display: flex;
              flex-direction: row;
              align-items: center;
              width: 60px;
              margin-right: 10px;
              text-align: left;
              color: #909399;
              flex: none;
            }

            .content {
              text-align: left;
              display: flex;
              flex-direction: row;
              align-items: center;

              .el-link {
                margin-left: 15px;
              }
            }
          }
        }

      }
    }

    .cutomer-source-analysis {
      .customer-source-title {
        padding: 20px 0px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        span {
          padding-right: 20px;
          color: #409eff;
          padding-bottom: 10px;
          border-bottom: 3px solid #409eff;
        }

        .customer-source-edit {
          position: relative;
          top: 0px;
          right: 0px;

          i {
            font-size: 20px;
            color: #909399;
          }
        }
      }

      .customer-source-content {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
      }
    }

    .customer-base-tag {
      .customer-base-title {
        padding: 20px 0px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        span {
          padding-right: 20px;
          color: #409eff;
          padding-bottom: 10px;
          border-bottom: 3px solid #409eff;
        }

        .customer-base-edit {
          position: relative;
          top: 0px;
          right: 0px;
          cursor: pointer;

          i {
            font-size: 20px;
            color: #909399;
          }
        }
      }

      .customer-base-content {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;

        .el-tag {
          margin-right: 20px;
          margin-top: 15px;
        }
      }
    }

  }

  .customer-followup {
    display: flex;
    flex-direction: column;
    width: 60%;
    display: flex;
    padding: 0px 20px;
    position: relative;
    .el-tabs__nav {
      padding: 8px;

      .el-tabs__header {
        font-size: 14px;
      }
    }

    .customer-followup-content {
      padding: 20px 20px;

      overflow-x: hidden;
      overflow-y: auto;
      .followTitle {
        margin-bottom: 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .follow-title-left{
          padding-right: 8px;
        }
      }
      .follow-content{
        .follow-replay-content{
          padding-top: 16px;
          /deep/.el-collapse{
            border-top: none!important;
            border-bottom: none!important;
          }
          /deep/.el-collapse-item__header{
            height: 30px;
            line-height: 30px;
            border-bottom: none;
          }
          /deep/.el-collapse-item__wrap{
            border-bottom: none;
          }
          /deep/.el-collapse-item__content{
            padding-bottom: 10px;
            padding-top: 8px;
          }
          .replay-item{
            padding-bottom: 6px;
            .replay-name-time{
             color: #616161;
              padding-bottom: 4px;
              .replay-editname{
                padding-right: 10px;
              }
            }
          }
          .replay-item:last-child{
            padding-bottom: 0;
          }
        }

      }

      .follow-up-opration {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        position: relative;
        top: 0px;
        right: 0px;
        margin-bottom: 10px;

        .oprationLeft {
          display: flex;
          justify-content: flex-start;
          align-items: center;

          .status {
            color: #909399;
            padding-bottom: 0px !important;
            margin-right: 20px;
            font-size: 14px;
          }
        }

        .el-card {
          .follow-up-view {
            color: #409eff !important;
            font-size: 20px;
            margin-left: 10px;
          }
        }

      }

    }
    .show-record-followup-content{
      height: calc(100vh - 300px);
      transition: all 0.3s;
    }
    .hide-record-followup-content{
      height: calc(100vh - 150px);
      transition: all 0.3s;
    }
    .add-record-record{
      position: absolute;
      bottom: 0px;
      width: calc(100% - 40px);
      background: white;
      box-shadow: 0 -2px 12px -1px rgb(0 0 0 / 10%);
      padding-top: 10px;
      .replay-btn{
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding-top: 16px;
      }
    }
    .show-record-record{
      transition: all 0.3s;
      height: 140px;
    }
    .hide-record-record{
      height: 0;
      transition: all 0.3s;
    }
  }
}
</style>